import SortAlphDesc from './SortAlphDesc'

export default SortAlphDesc
// eslint-disable-next-line import/export
export * from './SortAlphDesc'
